import * as React from 'react';
import CartService from '../../services/CartService';
import { CurrencyFormatter as Currency } from '../../utils/utils';
import Button from '../Button/Button';

interface IVoucherUsed {
  onClearVoucher: () => void;
}

class VoucherUsed extends React.Component<IVoucherUsed> {

  public render() {
    return (
      <div className="voucherUsed cf">
        <div className="voucherUsed__text">
          <div className="voucherUsed__voucherName">{CartService.GetInstance().voucherTitle}</div>
          <small>( - <Currency price={CartService.GetInstance().totalPriceBeforeDiscount - CartService.GetInstance().totalPriceWithIndividualCustomerVoucherDiscount} /> )</small>
        </div>
        <Button type="discountRemove" onClick={this.props.onClearVoucher}>
          Remove
        </Button>
      </div>
    );
  }
}

export default VoucherUsed;


// WEBPACK FOOTER //
// ./src/modules/VoucherUsed/VoucherUsed.tsx